import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api } from "../../lib/api";
import { Calendar, ArrowRight, Search } from "lucide-react";

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get(`/announcements?limit=30${q ? `&q=${encodeURIComponent(q)}` : ""}`).then((r) => setItems(r.data.items || [])), 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div>
      <PageHero title="Announcements" subtitle="Latest news, notices, and communications from the Society." breadcrumbs={["Home", "Announcements"]} />
      <section className="section container-page">
        <div className="mb-8 max-w-lg">
          <div className="relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search announcements…" className="form-input pl-9" data-testid="ann-search" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a, i) => (
            <FadeUp key={a.id} delay={i * 0.03} className="card-elev group flex flex-col">
              {a.image && <div className="aspect-[16/10] overflow-hidden"><img src={a.image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>}
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3">
                  <span className="text-[10px] uppercase tracking-widest text-brand-primary font-semibold">{a.category}</span>
                  <span className="text-xs text-brand-muted flex items-center gap-1"><Calendar size={12} /> {new Date(a.publish_date).toLocaleDateString()}</span>
                </div>
                <h3 className="font-serif text-lg font-bold text-brand-text mt-3 leading-snug line-clamp-2">{a.title}</h3>
                <p className="text-sm text-brand-muted mt-2 line-clamp-3">{a.summary}</p>
                <Link to={`/announcements/${a.slug}`} className="mt-auto pt-4 inline-flex items-center gap-1.5 text-brand-primary font-semibold text-sm">Read more <ArrowRight size={14} /></Link>
              </div>
            </FadeUp>
          ))}
          {items.length === 0 && <div className="col-span-full text-center text-brand-muted py-16">No announcements found.</div>}
        </div>
      </section>
    </div>
  );
}
